<template>
  <div class="background" style="min-height: 0px;">
    <div class="divider my-0" />
    <v-container>
      <v-row :class="isMobile ? '' : 'py-8'">
        <v-col
          :cols="isMobile ? 12 : 3"
          class="px-8 mt-4"
          :order="isMobile ? 1 : 4"
        >
          <div class="socialMediaTitle">
            Social Media
          </div>
          <v-row style="margin-top: 8px;">
            <v-col cols="3">
              <v-btn
                class="socialMediaIcon"
                icon
                @click="openLink(socialMedia.discord.link)"
              >
                <v-img :src="socialMedia.discord.image" width="24" />
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                class="socialMediaIcon"
                icon
                @click="openLink(socialMedia.twitter.link)"
              >
                <v-img :src="socialMedia.twitter.image" width="24" />
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                class="socialMediaIcon"
                icon
                @click="openLink(socialMedia.medium.link)"
              >
                <v-img :src="socialMedia.medium.image" width="24" />
              </v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn
                class="socialMediaIcon"
                icon
                @click="openLink(socialMedia.linktree.link)"
              >
                <v-img :src="socialMedia.linktree.image" width="24" />
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="!isMobile" cols="3" order="2">
          <v-row justify="center">
            <v-img :src="Logo" :width="279" style="max-width: 279px;" />
          </v-row>
        </v-col>
        <v-col class="px-8" :cols="isMobile ? 12 : 6" order="3">
          <div class="content1">
            Golden Moments
          </div>
          <div class="content2" style="margin-top: 16px;">
            Golden Moments is building a platform, issuing Digital Collectibles
            and ecosystem tokens based on the intellectual property rights of
            Golden Moments globally popular K-pop music artists
          </div>
          <!-- <div style="margin-top: 16px">
            <a class="link" href="/terms" target="_blank">
              Terms
            </a>
            <a class="link ml-6" href="/privacy" target="_blank">
              Privacy
            </a>
            <a class="link ml-6" href="/help" target="_blank">
              Help and Support
            </a>
          </div> -->
        </v-col>
        <v-col class="mt-8" cols="12" order="5">
          <div class="divider" />
          <div class="copyrightText">
            © 2023 Golden Moments. All rights reserved.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Logo from '@/assets/footer/logo.png';

  import DiscordIcon from '@/assets/footer/discord.png';
  import LinktreeIcon from '@/assets/footer/linktree.png';
  import TwitterIcon from '@/assets/footer/twitter.png';
  import MediumIcon from '@/assets/footer/medium.png';

  export default {
    props: ['isMobile'],

    data: () => ({
      Logo: Logo,
      socialMedia: {
        discord: {
          image: DiscordIcon,
          link: 'https://discord.com/invite/5U6B22yxmE',
        },
        twitter: {
          image: TwitterIcon,
          link: 'https://twitter.com/Momentibles',
        },
        linktree: {
          image: LinktreeIcon,
          link: 'https://linktr.ee/momentibles',
        },
        medium: {
          image: MediumIcon,
          link: 'https://momentibles.medium.com/',
        },
      },
    }),

    computed: {},
    methods: {
      openLink(link) {
        window.open(link, '_blank');
      },
    },
  };
</script>

<style scoped>
  .link {
    font-family: 'Work Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: -0.02em;

    color: #454c54;
  }

  .background {
    background: #fff;
  }

  .content1 {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 24px !important;
    line-height: 48px !important;
  }
  .content2 {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 19px !important;
    letter-spacing: -0.02em !important;

    color: #454c54 !important;
  }

  .socialMediaTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    text-transform: uppercase !important;
  }

  .socialMediaIcon {
    width: 24px !important;
    height: 24px !important;
  }

  .copyrightText {
    color: #c0c0c0;

    /* Regular/Body/Medium */
    font-family: Work Sans !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    letter-spacing: 0.035px !important;

    text-align: center;
  }
</style>
